import { NavigateOptions, To, useLocation, useNavigate, useParams } from 'react-router-dom';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import { injectIntl, IntlShape, WrappedComponentProps } from 'react-intl';
import React from 'react';

interface RouterProps {
  location: Location;
  navigate: (to: To, options?: NavigateOptions, isPromise?: boolean) => Promise<void> | void;
  params: Record<string, any>;
  onChange: (callback: VoidFunction) => void;
}

export const withFormica = <P extends FormicaProps>(
  Component: React.ComponentType<P>,
): React.FC<Omit<Omit<P, keyof FormicaProps>, keyof WrappedComponentProps>> => {
  const Wrapper: React.FC<Omit<P, keyof FormicaProps>> = (props) => {
    const location = useLocation();
    const navigate: (to: To, options?: NavigateOptions) => void = useNavigate();

    const newNavigate = (to: To, options?: NavigateOptions, isPromise?: boolean): Promise<void> => {
      if (isPromise) {
        return new Promise<void>((resolve, reject) => {
          navigate(to, options);
          const timeout = setTimeout(() => {
            resolve();
            clearInterval(interval);
          }, 5_000);
          const interval = setInterval(() => {
            const shifted = decodeURI(window.location.pathname.split('/').slice(2).join('/'));
            if ('/' + shifted === to) {
              clearInterval(interval);
              clearTimeout(timeout);
              resolve();
            }
          }, 10);
          /*
          if (typeof to === "string") {
            to = to
              .split("/")
              .map((t) => encodeURIComponent(t))
              .join("/");
          }
           */
        });
      } else {
        navigate(to, options);
        return Promise.resolve();
      }
    };

    const params = useParams();
    return <Component {...(props as P)} router={{ location, navigate: newNavigate, params }} />;
  };

  return injectIntl(Wrapper as any) as any;
};

export interface FormicaProps extends RouteProps {
  intl: IntlShape;
}

export interface RouteProps {
  router: RouterProps;
}
